<dx-select-box [items]="boards"
               [(value)]="board"
               (onValueChanged)="onBoardIdChanged()"
               displayExpr="name"></dx-select-box>
